import useTranslation from 'next-translate/useTranslation'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import { checkoutCapacityConflictRequestedTimeSelector } from '../../store/checkoutSelectors'
import getCapacityConflictRequestedTimeLabel from '../../utils/getCapacityConflictRequestedTimeLabel'
import useCapacityConflictActions from '../../hooks/useCapacityConflictActions'

import CapacityConflictFooter from './CapacityConflictFooter'
import CapacityConflictStepDescription from './CapacityConflictStepDescription'

/**
 * Nothing can be resolved inside the modal: the products can't be prepared, there
 * are no later times, and there is no order to delete because the request that was
 * refused was the one that would have created it. All that is left is another day.
 */
export default function CapacityConflictUnavailableStep() {
  const { t } = useTranslation('common')

  const { chooseAnotherDay, cancel } = useCapacityConflictActions()
  const requestedTime = useAppSelector(
    checkoutCapacityConflictRequestedTimeSelector,
  )

  const formattedRequestedTime = getCapacityConflictRequestedTimeLabel(
    requestedTime,
    t,
  )

  function handleClose() {
    cancel()
  }

  return (
    <>
      <CapacityConflictStepDescription>
        {t('checkoutCapacityConflict.unavailableStepMessage', {
          time: formattedRequestedTime,
        })}
      </CapacityConflictStepDescription>
      <CapacityConflictFooter
        secondaryLabel={t('checkoutCapacityConflict.cancelButton')}
        onSecondaryClick={handleClose}
        primaryLabel={t('checkoutCapacityConflict.chooseAnotherDayButton')}
        onPrimaryClick={chooseAnotherDay}
      />
    </>
  )
}
